import Datepicker from 'components/ReusableComponents/Datepicker'
import Dropdown from 'components/ReusableComponents/ManageHotel/Dropdown'
import Toggle from 'components/ReusableComponents/Toggle'
import CustomCampaignEstimation from 'features/CustomCampaigns/EditCampaign/Estimation'
import moment from 'moment'
import { useState } from 'react'
import { formatNumberAsThousands } from 'utils/priceHelpers'

import styles from './EditCampaign.module.scss'

const CampaignSetup = ({
  audienceId,
  setAudienceId,
  isEdibable,
  audiences,
  deliveryStartDate,
  setDeliveryStartDate,
  deliveryFinishDate,
  setDeliveryFinishDate
}) => {
  const audienceSize =
    audiences && audienceId && audiences.find(a => a.id === Number(audienceId)).size

  const [showCutOffDate, setShowCutOffDate] = useState(false)

  function handleChangeCutOffToggle(e) {
    const isChecked = e.target.checked

    if (isChecked) {
      setShowCutOffDate(true)
    } else {
      setShowCutOffDate(false)
      setDeliveryFinishDate(null)
    }
  }

  return (
    <>
      <div className={styles.accordionContent}>
        <div className={styles.audienceDropdownRow}>
          <Dropdown
            label="Audience"
            value={audienceId}
            disabled={!isEdibable}
            options={audiences.reduce(
              (prev, curr) => ({ ...prev, [curr.id]: curr.name }),
              {}
            )}
            onChange={e => setAudienceId(e.target.value)}
          />
          <p className={styles.audienceSize}>
            {audienceId && <>Approx. {formatNumberAsThousands(audienceSize)} </>}
            guests
          </p>
        </div>
        <div>
          <div className={styles.datepickerHolder}>
            <span className={styles.datepickerLabel}>Start sending texts on</span>
            <Datepicker
              disabled={!isEdibable}
              className={styles.datepicker}
              placeholderText="Select date"
              selected={deliveryStartDate ? moment(deliveryStartDate).toDate() : null}
              minDate={moment().toDate()}
              onChange={date =>
                setDeliveryStartDate(moment(date).startOf('day').format())
              }
            />
          </div>
          <label className={styles.cutOffToggleHolder}>
            <Toggle value={showCutOffDate} handleChange={handleChangeCutOffToggle} />
            <div className={styles.cutOffToggleLabel}>
              <p className={styles.cutOffToggleLabelTitle}>Add cut-off date</p>
              <p className={styles.cutOffToggleLabelDescription}>
                Enable this to stop sending texts at a certain date
              </p>
            </div>
          </label>
          {showCutOffDate && (
            <div className={styles.datepickerHolder}>
              <span className={styles.datepickerLabel}>Cut-off date</span>
              <Datepicker
                disabled={!isEdibable}
                className={styles.datepicker}
                placeholderText="Select date"
                selected={deliveryFinishDate ? moment(deliveryFinishDate).toDate() : null}
                minDate={
                  deliveryStartDate
                    ? moment(deliveryStartDate).toDate()
                    : moment().toDate()
                }
                onChange={date =>
                  setDeliveryFinishDate(moment(date).endOf('day').format())
                }
              />
            </div>
          )}
        </div>
      </div>
      <CustomCampaignEstimation
        deliveryStartDate={deliveryStartDate}
        deliveryFinishDate={deliveryFinishDate}
        audienceSize={audienceSize}
      />
    </>
  )
}

export default CampaignSetup
